import { CategoryResponse } from '../../../../types/api/CategoriesIndexTypes';

export const isolateSelectedCategoryOrSubcategorySlug = (slug: string): string => {
  if (slug.includes('--'))
    return slug.split('--')[1];
  return slug;
}

export const findAndFormatCategoryBySlug = (slug: string, categories: Array<CategoryResponse>): CategoryResponse => {
  // subcategories handling
  let categorySlug: string;
  let subcategorySlug: string;
  if (slug.includes('--')) {
    categorySlug = slug.split('--')[0];
    subcategorySlug = slug.split('--')[1];
  }
  else {
    categorySlug = slug as string;
  }

  let mainCategory: CategoryResponse = categories.find((c: CategoryResponse) => c.slug === categorySlug);
  let subcategory: CategoryResponse;

  if (!mainCategory) {
    for (let i = 0; i < categories.length; i++) {
      const iterationCategory = categories[i];
      const iterationSubcategory = iterationCategory.subcategories.find((c: CategoryResponse) => c.slug === categorySlug);
      if (!iterationSubcategory) continue;
        mainCategory = iterationCategory;
        subcategory = iterationSubcategory;
    }
  } else if (subcategorySlug) {
    subcategory = mainCategory.subcategories.find((sc: CategoryResponse) => sc.slug === subcategorySlug)
  }
  const category: CategoryResponse = subcategory || mainCategory;
  if (subcategorySlug)
    category.parent = {
      id: mainCategory.id,
      name: mainCategory.name,
      slug: mainCategory.slug
    };
  return category;
}

export const routerQueryIncludesCustomSearch = (query: any): boolean =>
  !!query.search || !!query.sort_by || !!query.category_permalink || !!query.membership_tier;
